// store/modules/stage.js
const state = {
  currentForm: null,
  selectedOptionOne: null,
  selectedOptionTwo: null,
  selectedJourney: null
}

const mutations = {
  SET_CURRENT_FORM(state, form) {
    state.currentForm = form
  },
  SET_SELECTED_OPTION_ONE(state, option) {
    state.selectedOptionOne = option
  },
  SET_SELECTED_OPTION_TWO(state, option) {
    state.selectedOptionTwo = option
  },
  SET_SELECTED_JOURNEY(state, journey) {
    state.selectedJourney = journey
  },
  RESET_STAGE(state) {
    state.currentForm = null
    state.selectedOptionOne = null
    state.selectedOptionTwo = null
  }
}

const actions = {
  setCurrentForm({ commit }, form) {
    commit('SET_CURRENT_FORM', form)
  },
  setSelectedOptionOne({ commit }, option) {
    commit('SET_SELECTED_OPTION_ONE', option)
  },
  setSelectedOptionTwo({ commit }, option) {
    commit('SET_SELECTED_OPTION_TWO', option)
  },
  setSelectedJourney({ commit }, journey) {
    commit('SET_SELECTED_JOURNEY', journey)
  },
  resetStage({ commit }) {
    commit('RESET_STAGE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
